import React from 'react'

class QuestionMark extends React.Component {
  render() {
    return (
      <svg className="questionMark" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
        <g fill="none" fillRule="evenodd">
          <circle cx="14" cy="14" r="14" fill="#404245" />
          <path
            fill="#999"
            d="M10 11c.201-.92.667-1.65 1.397-2.19S13.037 8 14.129 8c1.144 0 2.075.27 2.793.81C17.641 9.35 18 10.08 18 11c0 .977-.306 1.739-.918 2.284-.612.546-1.412.874-2.401.983v1.888h-1.465V13.51c1.19-.179 2.037-.444 2.543-.798.505-.353.758-.866.758-1.539 0-.574-.212-1.027-.638-1.357-.425-.33-1.043-.496-1.853-.496-.776 0-1.408.215-1.897.647-.488.43-.781 1.017-.879 1.758L10 11zm2.767 7.853c0-.339.107-.614.32-.827.212-.213.49-.32.835-.32.34 0 .615.107.828.32.213.213.319.488.319.827 0 .34-.106.615-.319.828-.213.213-.489.319-.828.319-.339 0-.616-.105-.831-.315-.216-.21-.324-.487-.324-.832z"
          />
        </g>
      </svg>
    )
  }
}

export default QuestionMark
